import React from "react";
import { motion } from "framer-motion";
import { FileText } from "lucide-react";

const SubmissionButton = ({ onClick, hasSubmitted }) => {
  return (
    <motion.button
      onClick={onClick}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.94 }}
      animate={
        hasSubmitted
          ? { scale: [1, 1.1, 1], rotate: [0, -3, 0] }
          : { scale: 1, rotate: 0 }
      }
      transition={{ type: "spring", stiffness: 200, damping: 18 }}
      title={hasSubmitted ? "Submission completed" : "Submit your work"}
      className={`fixed bottom-8 right-28 z-[10000] flex items-center justify-center
        h-14 w-14 rounded-2xl border transition-all duration-300
        shadow-[0_0_20px_rgba(255,255,255,0.08)] backdrop-blur-xl
        ${
          hasSubmitted
            ? "bg-neutral-900 border-white/10 text-white"
            : "bg-neutral-950 border-white/10 text-white hover:bg-neutral-800"
        }`}
    >
      <FileText size={22} className="text-white" />
      {hasSubmitted && (
        <motion.span
          layoutId="aura"
          initial={{ opacity: 0 }}
          animate={{
            opacity: [0.2, 0.6, 0.2],
            scale: [1, 1.15, 1],
            boxShadow: [
              "0 0 20px rgba(255,255,255,0.1)",
              "0 0 25px rgba(255,255,255,0.2)",
              "0 0 20px rgba(255,255,255,0.1)",
            ],
          }}
          transition={{ repeat: Infinity, duration: 2.5, ease: "easeInOut" }}
          className="absolute inset-0 rounded-2xl bg-white/5 blur-md"
        />
      )}
    </motion.button>
  );
};

export default SubmissionButton;
